import { BaseButtons, BaseTextInput, formattaData, formattaImportoMonetario } from "@lucan/base-ui"
import ConfigManager from "components/config/ConfigManager"
import { useVerbale } from "configuration/ConfigurazioneApi"
import { ELENCHI } from "configuration/ConfigurazioneElenchi"
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react"
import { Card, CardContent, Typography, Divider, Box, InputAdornment, CircularProgress } from "@mui/material";
import Titolo from "components/ui/Titolo";
import Sezione from "components/ui/Sezione";
import { calcolaStatoPagamentoVerbale, STATO_PAGAMENTO_VERBALE } from '../utilFrontoffice'
import BadgeStatoPagamento from 'components/ui/frontoffice/BadgeStatoPagamento';
import { FRONTOFFICE_PREAVVISO } from "configuration/frontoffice";
import useSchermoStretto from 'hook/useSchermoStretto'

const CFG = FRONTOFFICE_PREAVVISO

export default function Preavviso(props) {
  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_FRONTOFFICE_PREAVVISO]}
      render={propsConfig =>
        <PreavvisoInterno {...propsConfig} {...props} />
      }
    />
  )
}


function PreavvisoInterno({ val, txt, inputRef }) {
  const {
    ScatolaMessaggi,
    getVerbale,
    inAttesaDelServer
  } = useVerbale({ conCookie: true })

  const [value, setValue] = useState("");
  const [preavviso, setPreavviso] = useState(null)
  const [isValid, setIsValid] = useState(null); // null = non validato
  const [messaggioErrore, setMessaggioErrore] = useState(null)
  
  function vaiAlPagamento() {
    window.open('https://checkout.pagopa.it', '_blank')
  }
  function checkCodiceAvviso(valore) {
    let regex = /^([0-9]){18}/
    if (!regex.test(valore)) return false
    let valore_proimi16 = Number(valore.slice(0, 16))
    let ultimi2 = Number(valore.slice(16))
    return (valore_proimi16 % 93 === ultimi2)

  }
  async function cercaDaCodiceAvviso(valore) {
    setPreavviso(null)
    setIsValid(null)
    if (checkCodiceAvviso(valore)) {
      const { ok, data } = await getVerbale(valore)
      if (ok) {
        let pagamento = data.verbale.pagamenti.find(pagamen => pagamen.codice_avviso === valore)
        let preav = {
          codice_avviso: valore,
          ente: pagamento.ente_intestazione,
          codice_fiscale: pagamento.codice_fiscale_ente,
          targa: data.verbale.veicolo_targa,
          data: formattaData(data.verbale.contestazione_data),
          importo: formattaImportoMonetario(pagamento.i),
          stato: calcolaStatoPagamentoVerbale(data.verbale),
        }
        console.log(preav)
        setPreavviso(preav)
        setIsValid(true)
      }
      else {
        setIsValid(false)
        setMessaggioErrore(val(CFG.CODICE_AVVISO_CODICE_NON_VALIDO))
      }
    } else {
      setIsValid(false)
      setMessaggioErrore(val(CFG.CODICE_AVVISO_FORMATO_CODICE_NON_CORRETTO))
    }

  }

  const schermoStretto = useSchermoStretto()

  return (
    <Box ref={inputRef}>
      <Titolo>{txt(CFG.DESCRIZIONE)}</Titolo>
      <BaseTextInput
        label={val(CFG.CODICE_AVVISO)}
        name={'codice_avviso'}
        variant="outlined"
        onChange={(e) => {
          setValue(e.target.value)
          cercaDaCodiceAvviso(e.target.value)
        }}
        value={value}
        readOnly={inAttesaDelServer} // disabilita input durante "validazione"
        larghezza={schermoStretto ? 'fullWidth' : 30}
        InputProps={{
          endAdornment: value.length >= 18 && (
            <InputAdornment position="end">
              {inAttesaDelServer ? (
                <CircularProgress size={32} />
              ) : isValid === null ? null : isValid ? (
                <CheckIcon style={{ color: "green" }} />
              ) : (
                <CloseIcon style={{ color: "red" }} />
              )}
            </InputAdornment>
          ),

        }}
        {...(isValid === false && {
          error: true,
          messaggioAiuto: messaggioErrore
        })}
      />

      {ScatolaMessaggi}
      
      {preavviso &&
        <>
          <Sezione>
            <DatiPreavvisoInterno preavviso={preavviso} val={val} />
          </Sezione>
          <BaseButtons.Custom 
            testo={val(CFG.BOTTONE_PAGAMENTO)} 
            onClick={vaiAlPagamento}
            disabled={preavviso.stato !== STATO_PAGAMENTO_VERBALE.PAGABILE}
          />
        </>
      }
    </Box>
  )
}


function Riga({ label, value, bold }) {
  return (
    <Box mb={1}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body1" fontWeight={bold ? "bold" : "normal"}>
        {value}
      </Typography>
    </Box>
  );
}

function DatiPreavvisoInterno({
  preavviso:
  {
    codice_avviso,
    ente,
    codice_fiscale,
    targa,
    data,
    importo,
    stato,
  },
  val,
}) {
  return (
    <Card variant="outlined" sx={{ borderRadius: 2, boxShadow: 1 }}>
      <CardContent>
        {/* Codice Avviso in alto */}
        <Riga label={val(CFG.CODICE_AVVISO)} value={codice_avviso} bold />
        <Divider sx={{ my: 2 }} />
        {/* Altri campi */}
        <Riga label={val(CFG.ENTE_CREDITORE)} value={ente} bold />
        <Divider sx={{ my: 2 }} />
        <Riga label={val(CFG.CODICE_FISCALE_ENTE)} value={codice_fiscale} bold />
        <Divider sx={{ my: 2 }} />
        <Riga label={val(CFG.TARGA_VEICOLO)} value={targa} bold />
        <Divider sx={{ my: 2 }} />
        <Riga label={val(CFG.DATA_RILEVAZIONE)} value={data} bold />
        <Divider sx={{ my: 2 }} />
        <Riga label={val(CFG.IMPORTO)} value={importo} bold />
        <Divider sx={{ my: 2 }} />
        <BadgeStatoPagamento stato={stato} />
      </CardContent>
    </Card>
  );
}